import { useMutation, useQueryClient } from "@tanstack/react-query";
import { useParams } from "react-router-dom";
import { useApi } from "~hooks/apiHooks/useApi";
import type { CreateSeasonPoolModel } from "~pages/SeasonPools/types/seasonPoolModel.ts";
import type { PoolResponse } from "~types/pool.ts";

export const useCreateSeasonPool = () => {
  const { sport, organizationId, seasonId } = useParams();
  const request = useApi();
  const queryClient = useQueryClient();

  return useMutation<PoolResponse, Error, CreateSeasonPoolModel>({
    mutationFn: async ({ poolCode, ...poolData }) =>
      await request<PoolResponse>(`${sport}/o/${organizationId}/seasons/${seasonId}/pools`, {
        method: "POST",
        body: {
          poolCode,
          ...poolData,
        },
      }),
    onSuccess: async () => {
      await queryClient.invalidateQueries({ queryKey: ["seasonPools", sport, organizationId, seasonId] });
    },
  });
};
